/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PositionBase } from './PositionBase';
import {
    PositionBaseFromJSON,
    PositionBaseFromJSONTyped,
    PositionBaseToJSON,
} from './PositionBase';
import type { PositionCalculatedFields } from './PositionCalculatedFields';
import {
    PositionCalculatedFieldsFromJSON,
    PositionCalculatedFieldsFromJSONTyped,
    PositionCalculatedFieldsToJSON,
} from './PositionCalculatedFields';

/**
 * 
 * @export
 * @interface Position
 */
export interface Position {
    /**
     * 
     * @type {PositionBase}
     * @memberof Position
     */
    base: PositionBase;
    /**
     * 
     * @type {PositionCalculatedFields}
     * @memberof Position
     */
    calculated?: PositionCalculatedFields;
}

/**
 * Check if a given object implements the Position interface.
 */
export function instanceOfPosition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "base" in value;

    return isInstance;
}

export function PositionFromJSON(json: any): Position {
    return PositionFromJSONTyped(json, false);
}

export function PositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Position {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'base': PositionBaseFromJSON(json['base']),
        'calculated': !exists(json, 'calculated') ? undefined : PositionCalculatedFieldsFromJSON(json['calculated']),
    };
}

export function PositionToJSON(value?: Position | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'base': PositionBaseToJSON(value.base),
        'calculated': PositionCalculatedFieldsToJSON(value.calculated),
    };
}

